import { lazyWithPreload } from "@/utils/lazyWithPreload";

/**
 * Preloadable route components for navigation preloading
 * Separated from App.tsx to avoid circular dependencies
 */

// Main pages
export const ContactPage = lazyWithPreload(() => import("../pages/ContactPage"));
export const MortgagePage = lazyWithPreload(() => import("../pages/MortgagePage"));
export const PrivateLoanPage = lazyWithPreload(() => import("../pages/PrivateLoanPage"));
export const BusinessLoanPage = lazyWithPreload(() => import("../pages/BusinessLoanPage"));
export const KlarsprakPage = lazyWithPreload(() => import("../pages/KlarsprakPage"));
export const LoanWithoutUCPage = lazyWithPreload(() => import("../pages/LoanWithoutUCPage"));

// Tool pages
export const MortgageCalculatorPage = lazyWithPreload(() => import("../pages/MortgageCalculatorPage"));
export const PrivateLoanCalculatorPage = lazyWithPreload(() => import("../pages/PrivateLoanCalculatorPage"));
export const InterestRateCalculatorPage = lazyWithPreload(() => import("../pages/InterestRateCalculatorPage"));
export const KALPCalculatorPage = lazyWithPreload(() => import("../pages/KALPCalculatorPage"));
